

const darkToastStyle = {
    style: {
        background: '#2b2833', 
        color: '#FFFFFF'
    }
}

export const toastStyles = {
    dark: darkToastStyle
}